/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Email_LabelInputs */

const en_admin_user_detail_email_label = /** @type {(inputs: Admin_User_Detail_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email:`)
};

const de_admin_user_detail_email_label = /** @type {(inputs: Admin_User_Detail_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail:`)
};

/**
* | output |
* | --- |
* | "Email:" |
*
* @param {Admin_User_Detail_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_email_label = /** @type {((inputs?: Admin_User_Detail_Email_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Email_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_email_label(inputs)
	return en_admin_user_detail_email_label(inputs)
});